import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import type * as React from 'react';

const hintStyle = css`
	margin: 0;
	padding: 0.75rem 0.875rem;
	border-radius: ${theme.radii.medium};
	background-color: ${theme.colors.accentSurface};
	color: ${theme.colors.accentDark};
	font-family: ${theme.fonts.body};
	font-size: ${theme.fontSizes.medium};
	font-weight: ${theme.fontWeights.medium};
`;

type Props = {
	/** Whether a part of the document that shows or hides depending on this field reads this field. */
	readonly hasConditionalPassages: boolean;
	/** Labels of the other things this field drives: computed fields and lists. */
	readonly labels: readonly string[];
};

/** Warns that changing the value may show or hide parts of the document. */
const FieldConditionsHint: React.FC<Props> = ({ hasConditionalPassages, labels }) => {
	const driven = hasConditionalPassages ? ['des parties du document', ...labels] : labels;

	if (driven.length === 0) {
		return null;
	}

	return <p css={hintStyle}>Modifier ce champ peut afficher ou masquer : {driven.join(', ')}.</p>;
};

export default FieldConditionsHint;
